module.exports = __webpack_public_path__ + "img/ems01.794bb355.png";